"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.vestingTypes = void 0;
const tx_1 = require("cosmjs-types/cosmos/vesting/v1beta1/tx");
exports.vestingTypes = [
    ["/cosmos.vesting.v1beta1.MsgCreateVestingAccount", tx_1.MsgCreateVestingAccount],
];
